export const MAIN_PAGE_MAIN_CATEGORIES = 'MAIN_PAGE_MAIN_CATEGORIES'
export const MAIN_PAGE_TOP_SLIDER = 'MAIN_PAGE_TOP_SLIDER'
export const TOP_NAV_BAR_CATEGORIES = 'TOP_NAV_BAR_CATEGORIES'
export const STORE_MAIN_PAGE_MAIN_CATEGORIES = 'STORE_MAIN_PAGE_MAIN_CATEGORIES'
export const STORE_MAIN_PAGE_TOP_SLIDER = 'STORE_MAIN_PAGE_TOP_SLIDER'
export const STORE_TOP_NAV_BAR_CATEGORIES = 'STORE_TOP_NAV_BAR_CATEGORIES'
